import { ConsultingRoomData } from "../types/ConsultingRoom";
import { patientApiUrl } from "./api";

const API_URL = "/ConsultingRooms";

export const getData = async (): Promise<ConsultingRoomData[]> => {
  try {
    const res = await patientApiUrl.get<ConsultingRoomData[]>(API_URL);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get consulting rooms error: ${
        error.response?.data?.message || error.message
      }`
    );
    return [];
  }
};

export const getDataById = async (
  id: number
): Promise<ConsultingRoomData | null> => {
  try {
    const res = await patientApiUrl.get<ConsultingRoomData>(`${API_URL}/${id}`);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get consulting room error: ${
        error.response?.data?.message || error.message
      }`
    );
    return null;
  }
};

export const createData = async (
  data: Partial<ConsultingRoomData>
): Promise<ConsultingRoomData | null> => {
  try {
    const res = await patientApiUrl.post<ConsultingRoomData>(API_URL, data);
    return res.data;
  } catch (error: any) {
    console.error(
      `Create consulting room error: ${
        error.response?.data?.message || error.message
      }`
    );
    return null;
  }
};

export const updateData = async (
  id: number,
  data: Partial<ConsultingRoomData>
): Promise<ConsultingRoomData | null> => {
  try {
    const res = await patientApiUrl.put<ConsultingRoomData>(
      `${API_URL}/${id}`,
      data
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Update consulting room error: ${
        error.response?.data?.message || error.message
      }`
    );
    return null;
  }
};

export const deleteData = async (id: number): Promise<boolean> => {
  try {
    await patientApiUrl.delete(`${API_URL}/${id}`);
    return true;
  } catch (error: any) {
    console.error(
      `Delete consulting room error: ${
        error.response?.data?.message || error.message
      }`
    );
    return false;
  }
};
